import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=87bbe37e&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=87bbe37e&prod&scoped=true&lang=css"
import style1 from "./Registration.vue?vue&type=style&index=1&id=87bbe37e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bbe37e",
  null
  
)

export default component.exports